var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useTimeout, useTranslate } from 'react-admin';
import { styled } from '@mui/material';
export var DualListInputSkeleton = function (props) {
    var translate = useTranslate();
    var oneSecondHasPassed = useTimeout(1000);
    if (oneSecondHasPassed) {
        return (React.createElement(Root, __assign({ "aria-disabled": "true", "aria-label": translate('ra.message.loading') }, props)));
    }
    return null;
};
var Root = styled('div', {
    name: 'RaDualListInputSkeleton',
    overridesResolver: function (props, styles) { return styles.root; },
})(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.divider,
        borderStyle: 'none',
    });
});
